import { Routes } from '@angular/router';
import { EmailVerificationComponent } from './components/auth/email-verification/email-verification.component';
import { ForgotUserPasswordComponent } from './components/auth/forgot-user-password/forgot-user-password.component';
import { LoginComponent } from './components/auth/login/login.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { CreateCVCandidatesComponent } from './components/candidates/create-cvcandidates/create-cvcandidates.component';
import { CvPreviewCandidatesComponent } from './components/candidates/cv-preview-candidates/cv-preview-candidates.component';
import { JobOfferCandidatesComponent } from './components/candidates/job-offer-candidates/job-offer-candidates.component';
import { MainCandidatesComponent } from './components/candidates/main-candidates/main-candidates.component';
import { MyAccountCandidatesComponent } from './components/candidates/my-account-candidates/my-account-candidates.component';
import { MyCVCandidatesComponent } from './components/candidates/my-cvcandidates/my-cvcandidates.component';
import { TestDetailCandidatesComponent } from './components/candidates/test-detail-candidates/test-detail-candidates.component';
import { CreateJobOfferCompaniesComponent } from './components/companies/create-job-offer-companies/create-job-offer-companies.component';
import { JobOfferCompaniesComponent } from './components/companies/job-offer-companies/job-offer-companies.component';
import { MainCompaniesComponent } from './components/companies/main-companies/main-companies.component';
import { MyAccountCompaniesComponent } from './components/companies/my-account-companies/my-account-companies.component';
import { AboutUsPageComponent } from './components/main/about-us/about-us.component';
import { BecasComponent } from './components/main/becas/becas.component';
import { FreelancerDetailComponent } from './components/main/freelancer-detail/freelancer-detail.component';
import { FreelancerComponent } from './components/main/freelancer/freelancer.component';
import { JobSearchComponent } from './components/main/job-search/job-search.component';
import { JobComponent } from './components/main/job/job.component';
import { MainPageComponent } from './components/main/main/main.component';
import { RegisterComponent } from './components/main/register/register.component';
import { ShopDetailComponent } from './components/main/shop-detail/shop-detail.component';
import { ShopComponent } from './components/main/shop/shop.component';
import { CompaniesStatisticsComponent } from './components/statistics/companies-statistics/companies-statistics.component';
import { MainStatisticsComponent } from './components/statistics/main-statistics/main-statistics.component';
import { ProfessionsStatisticsComponent } from './components/statistics/professions-statistics/professions-statistics.component';
import { authGuard } from './guards/auth.guard';
import { LayoutComponent } from './layouts/layout/layout.component';
import { UserRole } from './models/security/user-role-enum';
import { LayoutAdminComponent } from './layouts/layout-admin/layout-admin.component';
import { MainAdminComponent } from './components/admin/main-admin/main-admin.component';
import { CandidatesAdminComponent } from './components/admin/candidates-admin/candidates-admin.component';
import { CompaniesAdminComponent } from './components/admin/companies-admin/companies-admin.component';
import { UsersAdminComponent } from './components/admin/users-admin/users-admin.component';
import { MyAccountAdminComponent } from './components/admin/my-account-admin/my-account-admin.component';
import { CatalogAdminComponent } from './components/admin/catalog-admin/catalog-admin.component';
import { CountryComponent } from './components/admin/country/country.component';
import { StateComponent } from './components/admin/state/state.component';
import { CitiesComponent } from './components/admin/cities/cities.component';
import { CertificationsComponent } from './components/admin/certifications/certifications.component';
import { EducationLevelsComponent } from './components/admin/educationlevels/educationlevels.component';
import { ContractTypesComponent } from './components/admin/contracttypes/contracttypes.component';
import { WorkExperienceLevelsComponent } from './components/admin/workexperiencelevels/workexperiencelevels.component';
import { SexesComponent } from './components/admin/sexes/sexes.component';
import { LanguagesComponent } from './components/admin/languages/languages.component';
import { LanguageLevelsComponent } from './components/admin/languageslevels/languageslevels.component';
import { SkillsComponent } from './components/admin/skills/skills.component';
import { SkillLevelsComponent } from './components/admin/skilllevels/skilllevels.component';
import { IdentityDocumentTypesComponent } from './components/admin/identitydocumenttypes/identitydocumenttypes.component';
import { HonorsComponent } from './components/admin/honors/honors.component';
import { CarouselsComponent } from './components/admin/carousels/carousels.component';
import { JobDetailComponent } from './components/main/main/job-detail/job-detail.component';
import { HomePageComponent } from './components/main/home-page/home-page.component';
import { EconomicactivitiesComponent } from './components/admin/economicactivities/economicactivities.component';
import { JobOfferDetailsCompaniesComponent } from './components/companies/job-offer-details-companies/job-offer-details-companies.component';
import { CompanyDetailsAdminComponent } from './components/admin/companies-admin/company-details-admin/company-details-admin.component';
import { CandidateDetailsAdminComponent } from './components/admin/candidates-admin/candidate-details-admin/candidate-details-admin.component';
import { AvailableServicesComponent } from './components/main/available-services/available-services.component';
import { ProfessionalProfilesComponent } from './components/admin/professional-profiles/professional-profiles.component';
import { FinancialParameterComponent } from './components/admin/financial-parameter/financial-parameter.component';
import { CatalogItemsComponent } from './components/admin/catalog-items/catalog-items.component';
import { PublicCatalogComponent } from './components/main/public-catalog/public-catalog.component';
import { ApproveRequestsComponent } from './components/admin/approve-requests/approve-requests.component';

export const routes: Routes = [
    {
      path: 'home',
      component: LayoutComponent,
      children: [
        {
          path: '',
          component: HomePageComponent
        },
        {
          path: 'job-detail/:jobOfferId',
          component: JobDetailComponent
        },
        {
          path: 'job/:jobOfferId',
          component: JobComponent
        },
        {
          path: 'about',
          component: AboutUsPageComponent
        },
        {
          path: 'shop',
          component: ShopComponent
        },
        {
          path: 'shop-detail',
          component: ShopDetailComponent
        },
        {
          path: 'becas',
          component: BecasComponent
        },
        {
          path: 'register',
          component: RegisterComponent
        },
        {
          path: 'search',
          component: JobSearchComponent
        },
        {
          path: 'freelancer',
          component: FreelancerComponent
        },
        {
          path: 'freelancer-detail/:userId/:resumeId',
          component: FreelancerDetailComponent
        },
        {
          path: 'available-services',
          component: AvailableServicesComponent,
          data: {
             roles: [UserRole.Member, UserRole.Company]
          }
        },
        {
          path: 'products',
          component: PublicCatalogComponent,
           data: {
             roles: [UserRole.Member, UserRole.Company]
          }
        },
      ]
    },
    {
      path: 'candidates',
      canActivate: [authGuard],
      canActivateChild: [authGuard],
      data: {
        roles: [UserRole.Member]
      },
      component: LayoutComponent,
      children: [
        {
          path: 'main',
          component: MainCandidatesComponent
        },
        {
          path: 'main-comparison',
          component: MainPageComponent
        },
        {
          path: 'my-cvs',
          component: MyCVCandidatesComponent
        },
        {
          path: 'create-cv',
          component: CreateCVCandidatesComponent
        },
        {
          path: 'cv/:resumeId',
          component: CreateCVCandidatesComponent
        },
        // {
        //   path: 'cv',
        //   component: CvCandidatesComponent
        // },
        {
          path: 'cv-preview/:resumeId',
          component: CvPreviewCandidatesComponent
        },
        {
          path: 'job-offers',
          component: JobOfferCandidatesComponent
        },
        {
          path: 'my-account',
          component: MyAccountCandidatesComponent
        },
        {
          path: 'test-detail',
          component: TestDetailCandidatesComponent
        },
      ]
    },
    {
      path: 'companies',
      canActivate: [authGuard],
      canActivateChild: [authGuard],
      data: {
        roles: [UserRole.Company]
      },
      component: LayoutComponent,
      children: [
        {
          path: 'main',
          component: MainCompaniesComponent
        },
        {
          path: 'job-offers',
          component: JobOfferCompaniesComponent
        },
        {
          path: 'create-job-offer',
          component: CreateJobOfferCompaniesComponent
        },
        {
          path: 'create-job-offer/:viewType/:jobOfferId',
          component: CreateJobOfferCompaniesComponent
        },
        {
          path: 'my-account',
          component: MyAccountCompaniesComponent
        },
        {
          path: 'job-offer-details/:jobOfferId',
          component: JobOfferDetailsCompaniesComponent
        },
      ]
    },
    {
      path: 'statistics',
      canActivate: [authGuard],
      canActivateChild: [authGuard],
      data: {
        roles: [UserRole.Admin]
      },
      component: LayoutComponent,
      children: [
        {
          path: 'main',
          component: MainStatisticsComponent
        },
        {
          path: 'professions',
          component: ProfessionsStatisticsComponent
        },
        {
          path: 'companies',
          component: CompaniesStatisticsComponent
        },
      ]
    },
    {
      path: 'admin',
      canActivate: [authGuard],
      canActivateChild: [authGuard],
      data: {
        roles: [UserRole.Admin]
      },
      component: LayoutAdminComponent,
      children: [
        {
          path: 'main',
          component: MainAdminComponent,
        },
        {
          path: 'candidates',
          component: CandidatesAdminComponent,
        },
        {
          path: 'candidates/:id',
          component: CandidateDetailsAdminComponent,
        },
        {
          path: 'companies',
          component: CompaniesAdminComponent,
        },
        {
          path: 'companies/:id',
          component: CompanyDetailsAdminComponent,
        },
        {
          path: 'users',
          component: UsersAdminComponent,
        },
        {
          path: 'my-account',
          component: MyAccountAdminComponent,
        },
        {
          path: 'catalogs',
          component: CatalogAdminComponent,
        },
        {
          path: 'country',
          component: CountryComponent,
        },
        {
          path: 'state',
          component: StateComponent,
        },
        {
          path: 'cities',
          component: CitiesComponent,
        },
        {
          path: 'certifications',
          component: CertificationsComponent,
        },
        {
          path: 'educationlevels',
          component: EducationLevelsComponent,
        },
        {
          path: 'contracttypes',
          component: ContractTypesComponent,
        },
        {
          path: 'experiencelevels',
          component: WorkExperienceLevelsComponent,
        },
        {
          path: 'sex',
          component: SexesComponent,
        },
        {
          path: 'languages',
          component: LanguagesComponent,
        },
        {
          path: 'languagelevels',
          component: LanguageLevelsComponent,
        },
        {
          path: 'skills',
          component: SkillsComponent,
        },
        {
          path: 'skilllevels',
          component: SkillLevelsComponent,
        },
        {
          path: 'identitytypes',
          component: IdentityDocumentTypesComponent,
        },
        {
          path: 'honors',
          component: HonorsComponent,
        },
        {
          path: 'carouselsadmin',
          component: CarouselsComponent,
        },
        {
          path: 'economicactivities',
          component: EconomicactivitiesComponent,
        },
        {
          path: 'professionalprofiles',
          component: ProfessionalProfilesComponent,
        },
        {
          path: 'financial-parameters',
          component: FinancialParameterComponent, 
        },
        {
          path: 'catalog-items',
          component: CatalogItemsComponent
        },
        {
          path: 'approve-requests',
          component: ApproveRequestsComponent
        }
      ]
    },
    {
      path: 'login',
      component: LoginComponent
    },
    { path: 'ForgotUser', component: ForgotUserPasswordComponent, data: {userName: true}},
    { path: 'ForgotPassword', component: ForgotUserPasswordComponent, data: {password: true}},
    { path: 'ResetPassword', component: ResetPasswordComponent},
    { path: 'email-verification', component: EmailVerificationComponent, canActivate: [authGuard] },
    {
      path: '**',
      pathMatch: 'full',
      redirectTo: '/home'
    },
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    // { path: 'dashboard', component: DashboardComponent },
    // { path: 'detail/:id', component: HeroDetailComponent },
    // { path: 'heroes', component: HeroesComponent }
  ];
